import { Radio, FormControlLabel as MuiFormControlLabel } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';

export const FlightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AirlineRadioWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  && {
    margin: 0;
    padding: 0;
  }
`;

export const RadioButton = styled(Radio)`
  &&& {
    padding: 0;

    & .MuiSvgIcon-root {
      color: ${({ theme }) => theme.primaryBackgroundColor};
      font-size: 18px;
    }

    & .Mui-checked {
      color: ${({ theme }) => theme.primaryBackgroundColor}; !important;
    }
  }
`;

export const AirlineLogo = styled(AirlineImg)`
  width: 18px;
  margin-left: 8px;
`;

export const FlightDetailContainer = styled.div`
  display: flex;
  margin-left: 12px;
  align-items: center;

  > * + * {
    margin-left: 8px;
  }
`;

export const FlightTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlightTimeText = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${ColorPalette.HEX.PineTree2};
`;

export const FlightAirportNameText = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const TurnDays = styled.span`
  position: absolute;
  right: -15px;
  top: -10px;
  width: 15px;
  font-size: 10px;
  text-align: left;
  color: ${({ theme }) => theme.cardFlight.primary};
`;

export const FlightTimeArrivalWrapper = styled.div`
  position: relative;
`;

export const FlightLuggages = styled.div`
  display: flex;
  justify-content: flex-end;

  > * + * {
    margin-left: 1px;
  }
`;

export const FlightLuggagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ExpandMoreButton = styled.button<{ rotated?: boolean }>`
  all: unset;
  display: flex;
  appearance: none;
  margin-left: 4px;
  cursor: pointer;

  ${(props) =>
    props.rotated &&
    css`
      transform: rotate(180deg);
    `}
`;

export const AirlineName = styled.span`
  font-size: 10px;
  color: ${ColorPalette.HEX.DimGray2};
`;

export const LeftColumn = styled.div`
  display: flex;
  align-items: center;
`;

export const RightColumn = styled.div`
  display: flex;
  align-items: center;
`;
